/* global Swiper */
itsoftApp.createModule("partners-btn", ["slidersLibrary"], function() {
    var box = $(".js-partners-pop");

    if (!box.length) {
        return false;
    }

    var btnNextClass = "js-partnerr-btn-n";
    var btnNext = $("." + btnNextClass);
    var btnPervClass = "js-partnerr-btn-p";
    var btnPerv = $("." + btnPervClass);
    var btn = $(".js-partnerr-btn");
    var boxCount = box.length/1;
    var attrBox = "data-num";
    var activeClass = "is-active";
    var attrBoxNum;

    $(".js-open-popup").on("click", function(){
        attrBoxNum = $(this).attr(attrBox)/1;

        if (attrBoxNum > boxCount){
            DEBUG && console.log("[module partner-btn] 1 :" +attrBoxNum +" boxCount: " +boxCount);
            attrBoxNum = 1;

        }else{
            DEBUG && console.log("[module partner-btn] 2 :" +attrBoxNum);

        }
        boxOpen(attrBoxNum);
        nextPerv(attrBoxNum);
        // touch(attrBoxNum);
    })

    $(".js-close-popup").on("click", function(){
        box.removeClass(activeClass);
    })

    function boxOpen(index){
        box.removeClass(activeClass);
        box.filter("["+attrBox+"='"+index+"']").addClass(activeClass);
        DEBUG && console.log("[module partner-btn] boxOpen " + index);

        initSlider(box.filter("["+attrBox+"='"+index+"']").find(".js-slider-3"));

    }

    var nextPerv = function(index){
        DEBUG && console.log("[module partner-btn] nextPerv index = " + index );
        if (index === 1){
            btnPerv.attr(attrBox, boxCount);
            btnNext.attr(attrBox, ++index);
            DEBUG && console.log("[module partner-btn] nextPerv = 1" );

        }else{
            if (index === boxCount){
                var atr = boxCount;
                btnPerv.attr(attrBox, --atr);
                btnNext.attr(attrBox, 1);
                DEBUG && console.log("[module partner-btn] nextPerv = n " );

            }else{
                var next = index + 1;
                btnPerv.attr(attrBox, --index);
                btnNext.attr(attrBox, next);
                DEBUG && console.log("[module partner-btn] nextPerv " );
            }
        }
    }

    btn.on("click", function(){
        var self = $(this);
        var num = self.attr(attrBox)/1;

        DEBUG && console.log("[module partner-btn] click num =  " + num);
        boxOpen(num);
        nextPerv(num);
    })


    function initSlider(sliderParent){
        if (!sliderParent.length) {
            return false;
        }

        var init = function() {

            var swiper = new Swiper(sliderParent.get(0), {
                pagination: ".js-pagination-3",
                autoplay: 10000,
                paginationClickable: true,
                mousewheelControl: false,
                spaceBetween: 30,
                loop:true,
                effect: "fade",
            });
            DEBUG && console.log("[module swiper] slider initialized");
        };

        itsoftApp.modules.slidersLibrary.addEvent(init);
    }


    var touchstartX = 0;
    var touchendX = 0;


    box.on("touchstart  mousedown", function(e) {
        DEBUG && console.log("[module partner-btn] touchstart" );
        //если касание, то вычисляем через event.originalEvent.touches[0]:
        if (e.type == "touchstart") {

            var touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0];
            touchstartX = (touch.clientX - $(e.target).offset().left);

        }
        else {
        //если нажата кнопка мышки:
            touchstartX = (e.offsetX || e.clientX - $(e.target).offset().left);

        }
    });

    box.on("touchend  mousedown", function(e) {
        DEBUG && console.log("[module partner-btn] touchend" );
        //если касание, то вычисляем через event.originalEvent.touches[0]:
        if (e.type == "touchend") {

            var touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0];
            touchendX = (touch.clientX - $(e.target).offset().left);

        }
        else {
        //если нажата кнопка мышки:
            touchendX = (e.offsetX || e.clientX - $(e.target).offset().left);

        }
        handleGesure();
    });

    function handleGesure() {

        DEBUG && console.log("[module partner-btn] handleGesure" );
        var num ;
        if (touchendX*1.3 < touchstartX) {
            num = btnNext.attr("data-num")/1;

            boxOpen(num);
            nextPerv(num);
            DEBUG && console.log("[module partner-btn] left" );
        }
        if (touchendX > touchstartX*1.3) {
            num = btnPerv.attr("data-num")/1;

            boxOpen(num);
            nextPerv(num);
            DEBUG && console.log("[module partner-btn] right" );
        }

        if (touchendX == touchstartX ) {
            DEBUG && console.log("[module partner-btn] tap!" );
        }
    }



});